module.exports = __webpack_public_path__ + "fonts/Flaticon.df69fc42.eot";